import React from "react";

// import logo from "../assets/navbar/logo.png";
//Router component
import NavbarLink from "../layout/navbar/components/NavbarLink";
//menu
import DisclosureLink from "../layout/navbar/components/DisclosureLink";
import CenterIcon from "../components/ui/CenterIcon";
import Logo from "../assets/komet-assets/NavLogo.png";
import userRegister from "../assets/navbar/newAccount.svg";

// logo png is here
export const navLogoComponent = (darkmode) => (
    <>
        {/* <img
            className="h-12 w-auto block lg:hidden"
            src={logo}
            alt="Workflow"
        /> */}
        <img className="h-10 sm:h-16 w-auto md:mr-0 mr-6" src={Logo} alt="Workflow" />
        {/* <Logo className="h-12 sm:h-16 w-auto smooth md:mr-0 mr-6 fill-ashGray-700 dark:fill-ashGray-300" /> */}
    </>
);
export const navbarClassName = (isNavbarHidden, isRTL, scrolling) =>
    // color of nav background
    ` ${!isRTL ? "en" : ""} ${scrolling && "bg-primary-container"}`;

// here are Buttons
export const NavbarRegisterComponent = ({ content }) => (
    <NavbarLink
        defualtHover=""
        to="/register"
        className="bg-yellow-500 border-none rounded-md font-mont  hover-shadow text-black border-2 group"
    >
        <span className="flex-center-both font-h2">
            <img src={userRegister} alt="userRegister" className="w-auto h-6" />
        </span>
        <span className="flex-center-both font-w-bold clr-text-primary smooth">{content}</span>
    </NavbarLink>
);

export const NavbarLoginComponent = ({ isRTL, content }) => (
    <NavbarLink
        to="/login"
        className="bg-yellow-50 border-yellow-400 border font-mont text-black rounded-md hover-shadow"
        defualtHover="hover:dark:border-opacity-100 group"
    >
        <CenterIcon
            icon="majesticons:login-half-circle"
            className="text-black font-h2 group-hover:rotate-[-360deg] smooth"
            nY="0"
        />
    </NavbarLink>
);
export const NavbarLinksComponent = ({ isRTL, content, language }) => (
    <div className="hidden md:flex text-base">
        <div className={`flex-center-both space-x-4 ${language === "ar" ? "space-x-reverse" : ""}`}>
            <NavbarLink defualtHover="" to="/" className="NavbarLink items-center  group">
                <span className="hidden md:block text-base">{content.home[language]}</span>
            </NavbarLink>
            <NavbarLink defualtHover="" to="/about_us" className="NavbarLink items-center  group">
                <span className="hidden md:block text-base">{content.aboutUs[language]}</span>
            </NavbarLink>
            <NavbarLink defualtHover="" to="/join_us" className="NavbarLink items-center  group">
                <span className="hidden md:block text-base">{content.careers[language]}</span>
            </NavbarLink>
        </div>
    </div>
);
export const DisclosureLoginComponent = ({ isRTL, content }) => (
    <DisclosureLink to="/login">
        <span className="text-yellow-500 flex-center-both font-h2">
            <CenterIcon icon={"ic:twotone-accessibility-new"} />
        </span>
        <span className="flex-center-both">{content}</span>
    </DisclosureLink>
);
export const DisclosureRegisterComponent = ({ content }) => (
    <DisclosureLink to="/register">
        <span className="flex-center-both font-h2 smooth text-sky-400 group-hover:text-sky-500 dark:group-hover:text-sky-500">
            <CenterIcon icon="material-symbols:tab-new-right-outline-rounded" />
        </span>
        {/* <UserAddIcon className="h-6 w-6 text-yellow-300" /> */}
        <span className="flex-center-both">{content}</span>
    </DisclosureLink>
);

export const domainName = "mahmoud-magdy.com";
